import {postCreateWithdrawals} from '../api/postCreateWithdrawals';

export const setPostCreateWithdrawals = (params, setIsPayout, setIsLoading) => {
    return async (dispatch, getState) => {
        try {
            await postCreateWithdrawals(params);
            if (setIsPayout) {
                setIsPayout(false);
            }
            if (setIsLoading) {
                setIsLoading(false)
            }
            alert('Успешно')

        } catch(error) {
            if (setIsPayout) {
                setIsPayout(false);
            }
            if (setIsLoading) {
                setIsLoading(false)
            }
            alert('Ошибка')
            if (error?.response?.status === 401) {
                localStorage.removeItem('token');
                window.location.replace(window.location.origin);
            }
        }
    }
}